import React, { useState, useEffect } from 'react';
import { forumApi } from '../../api/forum';
import TagBadge from './TagBadge';
import HrnbLoader from '../controls/HrnbLoader';
import '../../css/components/TagList.css';

/**
 * Список тегов — отображает популярные теги
 * @param {Object} props
 * @param {number} [props.limit=10] - Максимальное количество тегов
 * @param {Function} [props.onTagSelect] - Обработчик выбора тега
 * @param {string} [props.activeTag] - Активный тег (slug)
 */
export default function TagList({ limit = 10, onTagSelect, activeTag }) {
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTags();
    }, []);

    const fetchTags = async () => {
        try {
            setLoading(true);
            const data = await forumApi.listTags();
            setTags(data?.slice(0, limit) || []);
        } catch (err) {
            // Тихая ошибка — теги не критичны для работы форума
            console.warn('[TagList] Failed to fetch tags:', err.message);
            setTags([]);
        } finally {
            setLoading(false);
        }
    };

    const handleTagClick = (tag) => {
        if (onTagSelect) {
            onTagSelect(tag);
        }
    };

    if (loading) {
        return <HrnbLoader size="sm" />;
    }

    if (tags.length === 0) {
        return null;
    }

    return (
        <div className="tag-list">
            <h5 className="tag-list-title">Популярные теги</h5>
            <div className="tag-list-items">
                {tags.map((tag) => (
                    <TagBadge
                        key={tag.id || tag.slug}
                        tag={tag}
                        variant="default"
                        active={activeTag === (tag.slug || tag.name?.toLowerCase().replace(/\s+/g, '-'))}
                        onClick={handleTagClick}
                    />
                ))}
            </div>
        </div>
    );
}
